import _PublicationContentFTR, {
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
} from './publication-content/ts';

import GetFtr from './axel-publication-content/js/GetFtr.js';

export {
    _PublicationContentFTR as PublicationContentFTR,
    GetFtr,
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
};

export default _PublicationContentFTR;
